import type { TypedUseSelectorHook } from 'react-redux';
import { useStore, useDispatch, useSelector } from 'react-redux';

import type { AppStore, RootState, AppDispatch } from './types';

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export const useAppStore: () => AppStore = useStore;
